import { createAction } from 'redux-actions';

const userActions = {
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  LOG_OUT: 'LOG_OUT',
  FETCH_FAVORITE_MEMBERS: 'FETCH_FAVORITE_MEMBERS',
  FETCH_FAVORITE_MEMBERS_COMPLETED: 'FETCH_FAVORITE_MEMBERS_COMPLETED',
  FETCH_FAVORITE_MEMBERS_FAILED: 'FETCH_FAVORITE_MEMBERS_FAILED',
  CLEAR_FAVORITE_MEMBERS: 'CLEAR_FAVORITE_MEMBERS',
  FETCH_USER_SUBSCRIPTION: 'FETCH_USER_SUBSCRIPTION',
  FETCH_USER_SUBSCRIPTION_COMPLETED: 'FETCH_USER_SUBSCRIPTION_COMPLETED',
  FETCH_USER_SUBSCRIPTION_FAILED: 'FETCH_USER_SUBSCRIPTION_FAILED',
};

const actionCreators = {
  setUserProfile: createAction(userActions.SET_USER_PROFILE),
  logout: createAction(userActions.LOG_OUT),
  fetchFavoriteMembers: createAction(userActions.FETCH_FAVORITE_MEMBERS),
  fetchFavoriteMembersCompleted: createAction(
    userActions.FETCH_FAVORITE_MEMBERS_COMPLETED
  ),
  fetchFavoriteMembersFailed: createAction(
    userActions.FETCH_FAVORITE_MEMBERS_FAILED
  ),
  clearFavoriteMembers: createAction(userActions.CLEAR_FAVORITE_MEMBERS),
  fetchUserSubscription: createAction(userActions.FETCH_USER_SUBSCRIPTION),
  fetchUserSubscriptionCompleted: createAction(
    userActions.FETCH_USER_SUBSCRIPTION_COMPLETED
  ),
  fetchUserSubscriptionFailed: createAction(
    userActions.FETCH_USER_SUBSCRIPTION_FAILED
  ),
};

export { userActions as types, actionCreators };
